import { LinkBoxList } from 'ui/components';

export const LinkBoxListFeature: React.FC<Umbraco.LinkBoxList> = ({ content, settings }) => {
	return (
		<LinkBoxList
			items={content?.properties?.linkBoxes?.map((linkBox) => ({
				heading: linkBox?.content?.properties?.heading,
				links: linkBox?.content?.properties?.links?.map((item) => item?.content?.properties?.link) || [],
				moreElementsLink: linkBox?.content?.properties?.moreElementsLink,
				variant: linkBox?.content?.properties?.variant,
			}))}
			desktopWidth={settings?.properties?.itemDesktopWidth}
			mobileWidth={settings?.properties?.itemMobileWidth}
		/>
	);
};
